import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, size } from "lodash";

import { fetchGet, fetchPost } from "../../api/fetch";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import CustomInput from "../Common/CustomInput";
import CustomButton from "../Common/CustomButton";
import Note from "../Common/Note";

import { formatDate } from "../../utils/date";
import { getNoteAuthor } from "../../utils/notes";

import { eventGroups } from "../../constants/common";

import images from "../../assets/img/images";

const styles = (theme) => ({
  contentContainer: {
    maxWidth: "100%",
    [theme.breakpoints.up("sm")]: {
      padding: "24px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "12px",
    },
  },
});

const EventDetailsNotes = (props) => {
  const { classes, data, type } = props;
  const [notes, setNotes] = React.useState();
  const [editMode, setEditMode] = React.useState(false);
  const [newNote, setNewNote] = React.useState("");

  const eventId = get(data, ["id"]);

  React.useEffect(() => {
    fetchNotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId]);

  const fetchNotes = async () => {
    try {
      let notes = await fetchGet(
        `${type === eventGroups ? "event_groups" : "events"}/${eventId}/notes`
      );
      for (let i = 0; i < size(notes); i++) {
        let n = notes[i];
        n.author = await getNoteAuthor(n);
      }
      setNotes(notes);
    } catch (e) {
      console.log(e);
    }
  };

  const saveNote = async () => {
    setEditMode(false);
    try {
      await fetchPost(
        `${type === eventGroups ? "event_groups" : "events"}/${eventId}/notes`,
        {
          description: newNote,
        }
      );
    } catch (e) {
      console.log(e);
    }
    setNewNote();
    fetchNotes();
  };

  return (
    <Box className={props.classes.card}>
      <Grid container direction="column" className={classes.contentContainer}>
        <Grid item>
          <CustomButton
            variant="contained"
            color="primary"
            disabled={editMode}
            startIcon={
              <img
                src={editMode ? images.plusIconDarkGrey : images.plusIconWhite}
                alt="plus"
              />
            }
            onClick={() => setEditMode(true)}
            style={{ marginBottom: editMode ? "20px" : "0px" }}
          >
            {I18n.get("common_new")}
          </CustomButton>
        </Grid>
        {editMode && (
          <>
            <Grid item>
              <CustomInput
                name="description"
                value={newNote}
                onChange={(e) => setNewNote(e.target.value)}
                multiline={true}
                rows={5}
              />
            </Grid>
            <Grid item style={{ textAlign: "right" }}>
              <CustomButton
                color="primary"
                style={{ margin: "10px 10px 0px 0px" }}
                onClick={() => setEditMode(false)}
              >
                {I18n.get("site_cancel")}
              </CustomButton>
              <CustomButton
                variant="contained"
                color="primary"
                style={{ marginTop: "10px" }}
                disabled={newNote ? false : true}
                onClick={saveNote}
              >
                {I18n.get("site_save")}
              </CustomButton>
            </Grid>
          </>
        )}
        {notes &&
          notes
            .sort(
              (a, b) =>
                new Date(b.updated_on).getTime() -
                new Date(a.updated_on).getTime()
            )
            .map((note) => (
              <Grid item key={note.id}>
                <hr
                  style={{
                    borderLeft: "none",
                    margin: "25px",
                    color: "black",
                    opacity: "0.3",
                  }}
                />
                <Note
                  author={note.author || ""}
                  date={formatDate(note.updated_on)}
                  description={note.description}
                />
              </Grid>
            ))}
      </Grid>
    </Box>
  );
};

export default withStyles(styles)(EventDetailsNotes);
